import { useState } from 'react';

import { useFloatingResourceAddContext } from 'hooks/useFloatingResourceAddContext';

import { TEST_ID } from './constants';
import type { FloatingResourceAddOpenRequest, FunctionComponent, Props } from './types';

const FloatingResourceAddProvider: FunctionComponent<Props> = ({ children, testId = TEST_ID }) => {
    const [visible, setVisible] = useState(true);
    const [openRequest, setOpenRequest] = useState<FloatingResourceAddOpenRequest | null>(null);
    const { context } = useFloatingResourceAddContext();

    const requestOpen = (request: FloatingResourceAddOpenRequest) => {
        setOpenRequest(request);
    };

    const clearOpenRequest = () => {
        setOpenRequest(null);
    };

    return (
        <context.Provider
            data-testid={testId}
            value={{ clearOpenRequest, openRequest, requestOpen, setVisible, visible }}>
            {children}
        </context.Provider>
    );
};

FloatingResourceAddProvider.displayName = 'FloatingResourceAddProvider';

export default FloatingResourceAddProvider;
